/**
 * Poke / réveil — ordre user :
 * 1 lit → 2 stretch assis → 3 frotte yeux → 4 bâillement → 5 dégoûté → 6 café → 7 bras croisés
 * (dégoûté une seule fois — pas rejoué dans le dialogue après)
 */
import { ONYX_REF_FILES } from '../lib/onyx/onyxPoseAssets';

/** Durée d’affichage pleine opaque avant de lancer le crossfade suivant. */
const HOLD_MS = 320;
/** Chevauchement fondu A→B (ms) — rendu film. */
export const ONYX_WAKE_CROSSFADE_MS = 380;

export const ONYX_WAKE_SEQUENCE = {
  /** Crossfade partagé (stage + timers). */
  crossfadeMs: ONYX_WAKE_CROSSFADE_MS,
  frames: [
    {
      id: 'sleep-bed',
      src: ONYX_REF_FILES.sleep_bed,
      file: 'onyx_ref_sleep_bed.webp',
      durationMs: HOLD_MS + ONYX_WAKE_CROSSFADE_MS,
      label: '1 · Lit',
    },
    {
      id: 'wake-stretch',
      src: ONYX_REF_FILES.wake_1_stretch,
      file: 'onyx_ref_wake_1_stretch.webp',
      durationMs: HOLD_MS + ONYX_WAKE_CROSSFADE_MS,
      label: '2 · Stretch assis',
    },
    {
      id: 'wake-rub',
      src: ONYX_REF_FILES.wake_2_rub_eyes,
      file: 'onyx_ref_wake_2_rub_eyes.webp',
      durationMs: HOLD_MS + ONYX_WAKE_CROSSFADE_MS,
      label: '3 · Frotte yeux',
    },
    {
      id: 'wake-yawn',
      src: ONYX_REF_FILES.wake_3_yawn,
      file: 'onyx_ref_wake_3_yawn.webp',
      durationMs: HOLD_MS + ONYX_WAKE_CROSSFADE_MS,
      label: '4 · Bâillement',
    },
    {
      id: 'wake-disgust',
      src: ONYX_REF_FILES.hurt,
      file: 'onyx_ref_angry_upset.png',
      durationMs: HOLD_MS + ONYX_WAKE_CROSSFADE_MS,
      label: '5 · Dégoûté',
    },
    {
      id: 'wake-coffee',
      src: ONYX_REF_FILES.wake_coffee,
      file: 'onyx_ref_wake_coffee.webp',
      durationMs: HOLD_MS + ONYX_WAKE_CROSSFADE_MS,
      label: '6 · Café',
    },
    {
      id: 'wake-idle',
      src: ONYX_REF_FILES.idle_crossed,
      file: 'onyx_ref_idle_arms_crossed.png',
      durationMs: HOLD_MS + 200,
      label: '7 · Bras croisés',
    },
  ],
  bubbleHoldMs: 1400,
  get totalMs() {
    return this.frames.reduce((sum, f) => sum + f.durationMs, 0);
  },
  get totalWithBubbleMs() {
    return this.totalMs + this.bubbleHoldMs;
  },
} as const;

export type OnyxWakeFrameId = (typeof ONYX_WAKE_SEQUENCE.frames)[number]['id'];

/**
 * Who Onyx is — never “bot / chatbot” in any language.
 * Prose: onyxIdentity.json (no identity text hardcode here).
 */
import identityConfig from './onyxIdentity.json';

export const ONYX_IDENTITY = {
  name: 'Onyx',
  selfIntroEn: identityConfig.selfIntroEn,
  selfIntroFr: identityConfig.selfIntroFr,
  systemRule: identityConfig.systemRule,
} as const;

export const ONYX_WAKE_GREETING = 'You woke me up, dude.';

/** Onyx avatar size (px) inside help chat message rows. */
export const ONYX_CHAT_AVATAR_SIZE = 104;

/** Closed / open FAB mascot (PC + mobile) — discreet, ~½ of previous 168. */
export const ONYX_FAB_SIZE = 84;

export function onyxWakeFrameUrls(): string[] {
  return ONYX_WAKE_SEQUENCE.frames.map((f) => f.src);
}
